import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { StandardConfigurator } from "./component"
import { MainState } from "../main"

const selector2D = createSelector(
    (s: MainState) => ({
        images: s.wheelsList.configurator._2D.images,
        loading: s.wheelsList.configurator._2D.loading,
        rimSizes: s.wheelsList.configurator._2D.rimSizes,
        rimPositions: s.wheelsList.configurator._2D.rimPositions,
        renderHidden: s.wheelsList.configurator.renderHidden,
        selectedRimItem: s.wheelsList.base.selectedRimItem,
        display: s.wheelsList.configurator.display,
        has2DConfig: s.wheelsList.configurator.has2DConfig,
        show3D: s.wheelsList.configurator.show3D,
        selectedRimLoading: s.wheelsList.base.selectedRimLoading,
        selectedSize: s.wheelsList.base.selectedSize,
    }),
    (x) => x
)

export function Wrapper2D({ insideDialog }: { insideDialog?: boolean }) {
    const { display, has2DConfig, images, loading, renderHidden, rimPositions, rimSizes, selectedRimItem, show3D, selectedRimLoading, selectedSize } =
        useSelector(selector2D)

    if (!((display || renderHidden) && has2DConfig && !show3D)) {
        return null
    }

    return (
        <StandardConfigurator
            insideDialog={insideDialog}
            images={images}
            selectedRimItem={selectedRimItem}
            loading={loading}
            selectedSize={selectedSize}
            selectedRimLoading={selectedRimLoading}
            rimSizes={rimSizes}
            rimPositions={rimPositions}
            renderHidden={renderHidden}
        />
    )
}
